import { Decimal } from "decimal.js";

// 符号优先级
const operatorPriority = {
  "+": 1,
  "-": 1,
  "*": 2,
  "/": 2,
};

// 辅助函数，用于计算两个操作数之间和一个运算符的结果，并将结果入结果栈≥
function calculate(operator, operand1, operand2) {
  switch (operator) {
    case "+":
      return operand2.plus(operand1);
    case "-":
      return operand2.minus(operand1);
    case "*":
      return operand2.times(operand1);
    case "/":
      if (operand1.equals(0)) {
        throw new Error("Division by zero error.");
      }
      return operand2.dividedBy(operand1);
    default:
      throw new Error(`Unknown operator: ${operator}`);
  }
}
/**
 * 判断表达式是否合法，合法表达式：只包含数字、运算符、小数点和空格，不包含其他非法字符
 *
 * @param expression 要判断的表达式
 * @returns 如果表达式合法返回true，否则返回false
 */
function isValidExpression(expression) {
  const isValid = /^[\d+\-*/().\s]+$/.test(expression);
  if (!isValid) return false;

  // Additional checks can be added here (e.g., balanced parentheses)
  return true;
}

/**
 * 计算给定表达式的值
 * @param expression 表达式字符串，
 * 请确保表达式格式正确
 * 如 1 + 2 * (3 + 4) / 5 - 6
 * 注意：表达式中只允许包含数字、+-*\/()和空格，不允许包含其他字符
 * 不允许出现连续两个运算符，如++ -- +-*\/
 * @param precision 保留小数位数，默认为空，表示不做处理
 * @returns
 */
// eslint-disable-next-line import/prefer-default-export
export function calculateExpression(expression, precision) {
  if (!isValidExpression(expression)) {
    throw new Error("Invalid expression format.");
  }
  // 将表达式解析为运算符数组和操作数数组
  const elements =
    expression.replace(/\s+/g, "").match(/[-+*/()]|\d+\.?\d*/g) || [];
  // 运算符栈和结果栈
  const operatorStack = [];
  const resultStack = [];
  elements.forEach((element) => {
    if (/^\d/.test(element)) {
      resultStack.push(new Decimal(element));
    } else if (element === "(") {
      operatorStack.push(element);
    } else if (element === ")") {
      while (
        operatorStack.length &&
        operatorStack[operatorStack.length - 1] !== "("
      ) {
        const op = operatorStack.pop();
        resultStack.push(calculate(op, resultStack.pop(), resultStack.pop()));
      }
      operatorStack.pop(); // Pop the "("
    } else {
      while (
        operatorStack.length > 0 &&
        operatorPriority[element] <=
          operatorPriority[operatorStack[operatorStack.length - 1]]
      ) {
        const op = operatorStack.pop();
        resultStack.push(calculate(op, resultStack.pop(), resultStack.pop()));
      }
      operatorStack.push(element);
    }
  });

  // 将剩余的运算符依次计算
  while (operatorStack.length > 0) {
    const op = operatorStack.pop();
    resultStack.push(calculate(op, resultStack.pop(), resultStack.pop()));
  }

  // 最终结果即为结果栈中的唯一元素
  return typeof precision === "number"
    ? resultStack[0].toFixed(precision)
    : resultStack[0].toString();
}



// WEBPACK FOOTER //
// ./src/utils/math.js